import PropTypes from "prop-types";
import React from "react";
import FormField from "./FormField";

const YesNoField = ({name, label, ...props}) => {
  return (
    <FormField
      label={label} type="radio" name={name}
      options={[
        {label: "Yes", value: true},
        {label: "No", value: false}
      ]}
      {...props}
    />
  );
};

YesNoField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default YesNoField;
